<template>
  <div id="box" class="error">
    <div class="inner">
      <div class="scrollWrapper">
        <h1 v-html="title" />
        <p v-html="description" class="description" />
        <div class="expandWrapper">
          <img
            v-svg-inline
            class="img"
            src="../assets/imgs/error.svg"
            alt="error"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reuse",
  props: {
    redirectURL: {
      type: String,
      default: "",
    },
  },
  mounted() {
    localStorage.removeItem("login_challenge");
  },
  computed: {
    title() {
      return this.$t("authorizationError.reuse.title");
    },
    description() {
      return this.$t("authorizationError.reuse.description");
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper
    +flex()
    .img
      +size(100px)
  .wrapper
    +flex(space-between, center, row)
</style>